module.exports = __webpack_public_path__ + "img/brandUsers.ecdb8c30.svg";